import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { BookingIssue } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { BookingsTapeChartStore } from '@new/domains/bookingsTapeChart/stores/BookingsTapeChartStore'

import { FiltersSharedProps } from './Filters.types'

interface BookingIssuesProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const _BookingIssuesFilter: FC<BookingIssuesProps> = props => {
  const { bookingIssuesFiltered } = BookingsTapeChartStore
  const quantityOfIssues = bookingIssuesFiltered ?? null

  const issuesOptions = Object.keys(BookingIssue)
    .filter(issues => issues !== 'undefined')
    .map(issues => {
      const value = BookingIssue[issues as keyof typeof BookingIssue]

      return {
        value,
        hasFullWidth: true,
        label: (
          <>
            {capitalizeEachFirstLetter(value).replace(/_/g, ' ')}
            <span style={{ marginLeft: 'auto' }}>
              {quantityOfIssues[value as keyof typeof quantityOfIssues]}
            </span>
          </>
        ),
      }
    })

  return <CheckboxBasedFilter title="Booking Issues" options={issuesOptions} {...props} />
}

export const BookingIssuesFilter = observer(_BookingIssuesFilter)
